import template from './socialSecuritySearch.html';
import controller from './socialSecuritySearch.controller';
import './socialSecuritySearch.scss';

let socialSecuritySearchComponent = {
  restrict: 'E',
  bindings: {
    onSearch: '&',
  },
  template,
  controller
};

export default socialSecuritySearchComponent;



// WEBPACK FOOTER //
// ./client/app/social-security.module/components/socialSecuritySearch/socialSecuritySearch.component.js